import { apiErrorMessage } from './ApiError';
import { axiosApi } from './axios.api';
import { CustomerGroupModel } from '@app/interfaces/customer/group';

const url = `/api/customer/groups`;

export const getCustomerGroupsApi = async (): Promise<CustomerGroupModel[] | undefined> => {
  try {
    const response = await axiosApi.get<CustomerGroupModel[]>(url);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const getCustomerGroupApi = async (customerGroupId: number, formData: CustomerGroupModel) => {
  try {
    const response = await axiosApi.put(`${url}/${customerGroupId}`, formData);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const createCustomerGroupApi = async (data: CustomerGroupModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const updateCustomerGroupApi = async (customerGroupId: number, formData: CustomerGroupModel) => {
  try {
    const response = await axiosApi.put(`${url}/${customerGroupId}`, formData);
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const deleteCustomerGroupApi = async (customerGroupId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${customerGroupId}`);
    return response.data;
  } catch (e: any) {
    apiErrorMessage(e); // giữ lý do chặn xoá từ backend (422) thay vì 'Request failed...'
  }
};
